import React from 'react';

type IProps = {
  children: React.ReactNode;
};

const AuthFooter: React.FC<IProps> = ({ children }) => (
  <div className="auth-footer">{children}</div>
);

export default AuthFooter;
